import React, { useEffect } from "react";
import { Typography } from "@material-ui/core";
import { useFormikContext } from "formik";

export const isTrialPlanName = name => ["start", "gratis", "trial", "prueba"].includes(String(name || "").trim().toLowerCase());
export const TRIAL_FEATURES = ["useCampaigns", "useSchedules", "useInternalChat", "useExternalApi", "useKanban", "useOpenAi", "useIntegrations", "useFiles", "useNegocio", "useGroupCampaigns", "useStatusCampaigns"];

export default function PlanTrialPolicy() {
  const { values, setValues } = useFormikContext();
  const trial = isTrialPlanName(values.name);
  useEffect(() => {
    if (trial) setValues(previous => ({ ...previous, ...Object.fromEntries(TRIAL_FEATURES.map(key => [key, true])) }), false);
  }, [trial, setValues]);
  return trial ? <Typography variant="body2" color="textSecondary" style={{ marginBottom: 12 }}>El plan de prueba mantiene todas las funciones activas. Su duración se configura en los días de prueba; los cupos de funciones no pueden quedar en cero.</Typography> : null;
}
